module.exports = __webpack_public_path__ + "img/UA.cb8eb98c.svg";